const modalities = [
  {
    id: 0,
    name: 'Presencial',
    descriptions: ['Clases en tu campus en un horario específico.'],
    color: '#BF500B'
  },
  {
    id: 1,
    name: 'Virtual en vivo',
    descriptions: [
      'Clases por la plataforma Zoom en un horario específico.',
      'Las clases quedarán grabadas en caso no puedas conectarte.'
    ],
    color: '#0F6778'
  },
  {
    id: 2,
    name: 'Virtual 24/7',
    descriptions: [
      'Tu docente te acompañará y resolverá tus dudas en el momento en que lo necesites.',
      'Flexibilidad para conectarte en cualquier momento y del dispositivo que más te acomode.'
    ],
    color: '#B21F5F'
  }
];

export default modalities;
